import React, { Component } from 'react';
import {
  BrowserRouter as Router
} from 'react-router-dom';
import { hasTouch } from 'detect-touch';
import Network from 'react-network';
import { resetWeights, resetStore } from './Functions';

import Header from './components/Header';
import Routes from './components/Routes';
//import Online from './components/Online';
import Overlay from './components/Overlay';

resetStore();
resetWeights();

if (hasTouch) {
  document.documentElement.classList.add('touch');
} else {
  document.documentElement.classList.add('no-touch');
}

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      connectionStatus: null,
      overlayMessage: null,
      overlayToggle: false
    };

    this.overlayMessage = this.overlayMessage.bind(this);  
    this.overlayToggle = this.overlayToggle.bind(this);  
  }

  handleNetworkChange = ({ online }) => {
    if (online) {
      this.setState({connectionStatus: 'online'});

      // lets send some emails we have stored?
      if (localStorage.getItem('apcyoa')) {
        let ls = JSON.parse(localStorage.getItem('apcyoa')),
        lsManipulated = ls.slice(0);

        if (ls.length) {
          console.log('lets send some left over emails');
          for (let i = 0; i < ls.length; i++) {

            let sessionData = ls[i];
        
            fetch('/email', {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(sessionData)
            })
            .then(res => {
              if (!res.ok) {
                throw Error(res.statusText);
              }
              return res;
            })
            .then(function(res, i) {
              // successfully sent so remove from local storage
              lsManipulated.splice(i, 1);
              //console.log(lsManipulated);
              localStorage.setItem('apcyoa', JSON.stringify(lsManipulated));

            }).catch(function(error) {
              // failed
              console.log(error);

            });
          }
        }
      }
    } else {
      this.setState({connectionStatus: 'offline'});
    }
  }

  overlayMessage(message) {
    this.setState({
      overlayMessage: message
    });
  }

  overlayToggle(status){
    this.setState({
      overlayToggle: status
    });
  }

  componentDidMount() {
    document.body.classList.add('app-loaded');
  }

  render() {

    return (
      <React.Fragment>
        <Header />
        <main className="screen">
          <section className="screen__image">
            <figure className="screen__image-image screen__image-image--intro" style={{backgroundImage: 'url(images/welcome-screen-bg.jpg)'}}></figure>
            <figure className="screen__image-image screen__image-image--questions" style={{backgroundImage: 'url(images/questions-bg.jpg)'}}></figure>
            <figure className="screen__image-image screen__image-image--results-recommendations" style={{backgroundImage: 'url(images/results-bg.jpg)'}}></figure>
          </section>
          <section className="screen__bg-color"></section>
          <section className="screen__content">
            <div className="screen__content-wrap">
            <Router>
              <Routes connectionStatus={this.state.connectionStatus} overlayMessage={this.overlayMessage} overlayToggle={this.overlayToggle} />
            </Router>
            </div>
          </section>
        </main>
        <Network onChange={this.handleNetworkChange} />
        {/*process.env.NODE_ENV === 'development' &&
          <Online connectionStatus={this.state.connectionStatus} />
        */}
        <Overlay overlayMessage={this.state.overlayMessage} overlayToggle={this.state.overlayToggle} />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js